<div class="position-relative d-flex p-3 p-md-5 m-md-3 text-center bg-dark intro-banner">
  <div class="col-md-8 p-lg-5 mx-auto text-white align-self-center">
    <h1 class="display-5 font-weight-bold mx-auto">{{'Secteur universitaire' | translate}}</h1>
  </div>
</div>
<contact-us-btn></contact-us-btn>
<hr class="mb-5 mt-3">
<div class="container">
    <div class="text-center mt-5 mb-5">
        <span class="title sub-bar">{{'Analyse du secteur universitaire' | translate}}</span>
    </div>
    <div class="container justif-center mb-5 pb-3">
      <p><span class="bold-blue">{{ 'L’université' | translate}}</span> {{'est une institution d’enseignement supérieur, composée de centres d’études et de recherches, de bibliothèque, médiathèque. Son statut est soit privé ou public et sa mission première est de participer au développement des' | translate}} <span class="font-weight-bold">{{ 'compétences' | translate}}</span> {{ 'des individus' | translate}}.</p>
      <p>{{ 'Le marché du e-learning' | translate }}, {{'aussi appelé l’apprentissage virtuel' | translate}}, {{'a désormais 22 ans et ne cesse de croître dans le' | translate}} <span class="bold-blue">{{'secteur universitaire' | translate}}</span>. {{'Entre 2015 et 2025, la taille du marché du e-learning devrait doubler pour atteindre $325 milliards, l’utilisation des nouvelles technologies et des apprentissages virtuels ne cessent de croître' | translate}}.</p>
      <p>{{ 'La crise sanitaire liée à la pandémie du Covid-19 a eu un réel impact sur la pédagogie et a obligé bons nombres d’écoles' | translate}}, <span class="bold-blue">{{ 'd’universités' | translate}}</span> {{'et de centres de formation à délaisser les enseignements en présentiel au profit des classes virtuelles (Bonfils, 2020)(Daniel, 2020). Cela a entraîné un emploi massif d’outils technologiques de type visioconférence à l’instar de Zoom et a ouvert des perspectives en termes de pratiques pédagogiques (Lépinard, 2020)' | translate}}.</p>
      <div class="block-tendances block-rounded py-4 px-5 mt-4">
        <h5 class="pt-2 font-weight-bold title-blue text-uppercase">{{'Futures tendances :' | translate}}</h5>
        <p>{{ 'Les établissements d’enseignement supérieur commenceront bientôt à mettre en œuvre des outils d’apprentissage virtuel : VR (réalité virtuelle) et AR (réalité augmentée) dans leurs programmes à moyen terme. C’est déjà le cas pour les étudiants en médecine de l’Université de Fisk aux Etats Unis*. L’objectif est de trouver un savant dosage afin de renforcer l’impact des cours sur ceux qui les reçoivent' | translate}}. <a class="source" href="https://www.fisk.edu/featured/fisk-university-htc-vive-t-mobile-and-victoryxr-launch-5g-powered-vr-human-cadaver-lab/" target="_blank" rel="noopener nofollow" title="fisk edu">(*source)</a></p>
      </div>
    </div>
</div>
<div class="block-free-access py-5">
    <div class="container px-5">
        <div class="block p-0">
            <ul class="nav landing-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="global-tab" data-toggle="tab" href="#global" role="tab" aria-controls="global" aria-selected="true" title="World">
                        <div class="icon">
                          <picture>
            									<source srcset="/assets/world_icon.webp" type="image/webp">
                              <source srcset="/assets/world_icon.png" type="image/png">
            									<img src="/assets/world_icon.png" class="pays" alt="Global university sector trends: Accidentology and Market Analysis" title="World" loading="lazy"/>
            							</picture>
                        </div>
                        <b class="text-uppercase">{{'Global' | translate}}</b>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="usa-tab" data-toggle="tab" href="#usa" role="tab" aria-controls="usa" aria-selected="false" title="USA">
                        <div class="icon">
                          <picture>
            									<source srcset="/assets/usa_icon.webp" type="image/webp">
                              <source srcset="/assets/usa_icon.png" type="image/png">
            									<img src="/assets/usa_icon.png" class="pays" alt="United States university sector trends: Accidentology and Market Analysis" title="USA" loading="lazy"/>
            							</picture>
                        </div>
                        <b class="text-uppercase">{{'Etats-Unis' | translate}}</b>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="europe-tab" data-toggle="tab" href="#europe" role="tab" aria-controls="europe" aria-selected="false" title="Europe">
                        <div class="icon">
                          <picture>
            									<source srcset="/assets/europe_icon.webp" type="image/webp">
                              <source srcset="/assets/europe_icon.png" type="image/png">
            									<img class="pays" src="/assets/europe_icon.png" alt="Europe university sector trends: Accidentology and Market Analysis" title="Europe" loading="lazy">
            							</picture>
                        </div>
                        <b class="text-uppercase">{{'Europe' | translate}}</b>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="france-tab" data-toggle="tab" href="#france" role="tab" aria-controls="france" aria-selected="false" title="France">
                        <div class="icon">
                          <picture>
            									<source srcset="/assets/france_icon.webp" type="image/webp">
                              <source srcset="/assets/france_icon.png" type="image/png">
            									<img src="/assets/france_icon.png" class="pays" alt="French university sector trends: Accidentology and Market Analysis" title="France" loading="lazy"/>
            							</picture>
                        </div>
                        <b class="text-uppercase">{{'France' | translate}}</b>
                    </a>
                </li>
            </ul>
            <hr class="my-0">
            <div class="tab-content text-center py-5 px-3 px-md-5" id="myTabContent">
                <div class="tab-pane fade show active" id="global" role="tabpanel" aria-labelledby="global-tab">
                    <b class="sub-bar">{{'GLOBAL' | translate}}</b>
                    <ul class="mb-0 mt-4 text-justify">
                      <li>{{'L’emploi de l’apprentissage en ligne peut augmenter les taux de rétention des étudiants de 25 à 60%' | translate}}. <a class="source" href="https://www.forbes.com/sites/paycom/2017/02/14/learning-management-systems-101-rethinking-your-approach-to-employee-training/" target="_blank" rel="noopener nofollow" title="forbes">{{'(Forbes)' | translate}}</a></li>
                      <li>{{'10 des plus grands établissements d’enseignement au monde accueillent jusqu’à 20% de tous les étudiants en ligne' | translate}}. <a class="source" href="https://e-student.org/e-learning-statistics/" target="_blank" rel="noopener nofollow" title="e student">{{'(Ed Surge)' | translate}}</a></li>
                      <li>{{'57% des élèves se voient attribuer des appareils mobiles personnels à usage scolaire' | translate}}. <a class="source" href="https://tomorrow.org/speakup/speakup-2017-how-students-use-mobile-devices-for-learning-june2018.html" target="_blank" rel="noopener nofollow" title="tomorrow">{{'(Tomorrow)' | translate}}</a>. {{'Les classes virtuelles peuvent être un réel point fort comme un réel challenge pour certains étudiants, peu concentrés durant les cours en ligne et lassés du contact virtuel' | translate}}.</li>
                      <li>{{'Pour 86% des diplômés en ligne, la valeur tirée de leur diplôme en ligne dépassait ou équivalait au coût qu’ils avaient payé pour cela' | translate}}. <a class="source" href="https://research.com/education/online-education-statistics" target="_blank" rel="noopener nofollow" title="research">{{'(Learning House)' | translate}}</a></li>
                    </ul>
                </div>
                <div class="tab-pane fade" id="usa" role="tabpanel" aria-labelledby="usa-tab">
                  <b class="sub-bar">{{'ETATS-UNIS' | translate}}</b>
                  <ul class="mb-0 mt-4 text-justify">
                    <li>{{'7% des étudiants inscrits à un diplôme de premier cycle sont passés à l’enseignement en ligne en 2020' | translate}}.</li>
                    <li>{{'81% des étudiants américains reconnaissent que la technologie d’apprentissage numérique les aidait à améliorer leurs notes' | translate}}. <a class="source" href="https://www.mheducation.com/news-media/press-releases/2016-digital-study-trends-survey.html" target="_blank" rel="noopener nofollow" title="mheducation">{{'(source)' | translate}}</a></li>
                    <li>{{'43% des établissements universitaires offrant un enseignement supérieur ont investi dans de nouvelles ressources d’enseignement à distance pour s’équiper pour l’enseignement à distance' | translate}}.</li>
                    <li>{{'67% des étudiants en apprentissage à distance utilisent des appareils mobiles tels que des smartphones et des tablettes pour terminer leurs cours' | translate}}. <a class="source" href="https://www.unomaha.edu/online-learning/online-experience/index.php" target="_blank" rel="noopener nofollow" title="unomaha">{{'(source)' | translate}}</a></li>
                    <li>{{'Les 8 écoles de l’Ivy League ont déjà adopté l’enseignement en ligne' | translate}}. <a class="source" href="hhttps://review42.com/resources/online-education-statistics/" target="_blank" rel="noopener nofollow" title="review42">{{'(source)' | translate}}</a></li>
                  </ul>
                </div>
                <div class="tab-pane fade" id="europe" role="tabpanel" aria-labelledby="europe-tab">
                  <b class="sub-bar">{{'EUROPE' | translate}}</b>
                  <ul class="mb-0 mt-4 text-justify">
                    <li>{{'En 2019, 8% des personnes âgées de 16 à 74 ans dans l’UE ont déclaré avoir suivi un cours en ligne au cours des 3 derniers mois. Par rapport à 2010, la part des personnes suivant un cours en ligne a doublé, passant à 4%' | translate}}. <a class="source" href="https://ec.europa.eu/eurostat/fr/web/products-eurostat-news/-/edn-20200517-1" target="_blank" rel="noopener nofollow" title="europa eurostat">{{'(source)' | translate}}</a></li>
                    <li>{{'Les jeunes, âgés de 16 à 24 ans, suivent généralement des cours en ligne plus fréquemment que la population adulte moyenne' | translate}}. <a class="source" href="https://ec.europa.eu/eurostat/fr/web/products-eurostat-news/product/-/asset_publisher/VWJkHuaYvLIN/content/EDN-20200517-1/pop_up" target="_blank" rel="noopener nofollow" title="europa eurostat">{{'(source)' | translate}}</a></li>
                  </ul>
                </div>
                <div class="tab-pane fade" id="france" role="tabpanel" aria-labelledby="france-tab">
                  <b class="sub-bar">{{'FRANCE' | translate}}</b>
                  <ul class="mb-0 mt-4 text-justify">
                    <li>{{'Selon un sondage, 24% des étudiants avaient déjà vécu l’apprentissage à distance avant le confinement du printemps 2020, dont environ 60% considéraient l’expérience comme positive ou très positive' | translate}}. <a class="source" href="https://journals.openedition.org/dms/6166" target="_blank" rel="noopener nofollow" title="journals openedition">{{'(source)' | translate}}</a></li>
                    <li>{{'Interrogés sur leur expérience imposée pendant le confinement, seuls 35% des étudiants considèrent l’expérience comme positive' | translate}}. <a class="source" href="https://journals.openedition.org/dms/6166" target="_blank" rel="noopener nofollow" title="journals openedition">{{'(source)' | translate}}</a></li>
                  </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container my-5">
    <div class="text-center mb-5">
        <span class="title sub-bar">{{'Challenges du secteur' | translate}}</span>
    </div>
    <div class="row pt-2">
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/1-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'Augmenter l’engagement face au cours et activités virtuels et la rétention des étudiants face à cette nouvelle forme de pédagogie' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'L’apprentissage immersif, via une plate-forme plus attrayante qu’une simple visioconférence Zoom ou Google Meet, permet de renforcer l’engagement et d’améliorer la rétention grâce à l’expérience. En effet, un environnement virtuel 3D proche du jeu vidéo aide à stimuler la motivation des étudiants. L’étudiant est responsabilisé et sa concentration est requise puisqu’il est placé au cœur de l’action dans ce monde virtuel : l’expérience concrète saisit son attention. Les challenges sont aussi d’ouvrir des portes au monde du travail virtuel aux futurs étudiants : le marché du travail de demain' | translate}}.
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 mb-md-4 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/campus.webp" type="image/webp">
                <source srcset="assets/campus.jpg" type="image/jpg">
                <img src="assets/campus.jpg" class="block-rounded abstract-formation" alt="Immersive Factory virtual campus hall" title="Virtual Campus" loading="lazy">
            </picture>
        </div>
        <!-- <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
          <div class="videoContainer block-rounded shadow mb-2">
              <video poster="https://immersivemisc.s3.eu-west-3.amazonaws.com/videos/posters/Accident.jpg" autoplay="autoplay" muted="muted" webkit-playsinline="true" playsinline="true" loop="loop" preload="auto">
                  <source src="https://immersivemisc.s3.eu-west-3.amazonaws.com/videos/Accidents.webm" type="video/webm">
                  <source src="https://immersivemisc.s3.eu-west-3.amazonaws.com/videos/Accidents.mp4" type="video/mp4">
              </video>
          </div>
        </div> -->
    </div>
    <hr class="px-2 mb-4">
    <div class="row pt-4">
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
            <!-- <img src="assets/{{'gif-fr-competences-formations.gif' | translate}}" class="block-rounded" alt="An immersive virtual campus"> -->
            <app-slider [slides]="slides" class="col-md-6"></app-slider>
        </div>
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/2-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'Rompre l’isolement des étudiants, lorsque les moyens traditionnels ne sont pas disponibles' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'Le campus virtuel est une plateforme inclusive conçue pour la socialisation et l’interaction et qui favorise le bien-être puisqu’elle est adaptée à chaque besoin ou chaque contrainte des utilisateurs virtuels (handicap, langues, mode de travail etc). Elle peut accueillir plusieurs dizaines d’étudiants ou plusieurs centaines sur différents campus, et facilite l’organisation de toutes sortes d’évènements, conférences, formels et informels assurant un lien social. Une expérience unique et innovante où les utilisateurs peuvent venir travailler ensemble de manière ludique et conviviale' | translate}}.
                </div>
            </div>
        </div>
    </div>
    <hr class="px-2 my-4">
    <div class="row pt-4">
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/3-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'Construire et animer une communauté et un apprentissage virtuel' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'Un environnement totalement immersif sans stress alternant zones de travail et de détente: salles de cours, salles de réunion, patio, etc.. Avec pour objectif l’implication, la participation, la satisfaction, l’expérience. Des outils d’engagement et de participation dans chaque salle : sondage, chatbox, visionneuse pdf, cinéma pour présenter des vidéos youtube, etc pour recueillir l’avis des étudiants et améliorer l’approche pédagogique si nécessaire' | translate}}.
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6 mb-md-4 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/new_training_room.webp" type="image/webp">
                <source srcset="assets/new_training_room.jpg" type="image/jpg">
                <img src="assets/new_training_room.jpg" class="block-rounded abstract-formation" alt="Immersive Factory virtual campus training room" title="Training room" loading="lazy">
            </picture>
        </div>
    </div>
    <hr class="px-2 mb-4">
    <div class="row pt-4">
        <!-- <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
            <img src="assets/{{'pharma-proteger-accidents.png' | translate}}" class="block-rounded" alt="VR training workshops increase learner memory by 4">
        </div> -->
        <div class="col-12 col-md-6 mb-md-0 px-4 mb-md-4 mb-4">
            <picture>
                <source srcset="assets/Conference_people_04.webp" type="image/webp">
                <source srcset="assets/Conference_people_04.jpg" type="image/jpg">
                <img src="assets/Conference_people_04.jpg" class="block-rounded" alt="Immersive virtual campus conference room" title="Conference room" loading="lazy">
            </picture>
        </div>
        <div class="col-12 col-md-6 px-4 pt-4 mb-md-4 mb-4 d-flex justify-content-center align-items-center">
            <div>
                <p class="challenge"><app-svg-icon [src]="'assets/svg/4-icone.svg'" [size]="'28px'" class="fas mr-2 custom-circle number-icon"></app-svg-icon>{{'Viser l’efficience pédagogique pour favoriser l’insertion professionnelle des apprenants' | translate}}</p>
                <div class="vertical-line">
                  <p class="font-weight-bold ifsolution">{{'Comment la solution d’Immersive Factory aide à surmonter ce défi :' | translate}}</p>
                  {{'L’usage de jeux sérieux (ou jeu pédagogique) en mode distanciel et virtuel disponible quelle que soit l’heure ou le lieu, permet une grande flexibilité, notamment celle d’associer une formation traditionnelle afin de rompre avec la routine et in fine, de susciter l’intérêt, la curiosité et le développement d’un apprentissage tout en collant au plus près des évolutions et des préoccupations des entreprises. La pédagogie active dans un environnement stimulant et virtuel augmente les chances de réussite des parcours d’apprentissage' | translate}}.
                </div>
            </div>
        </div>
    </div>

    <div class="mt-4 mb-1 green block-info block-rounded py-5 px-5 text-justify-center">
      <span class="fa-stack green-icon mb-3">
        <i class="fas fa-circle fa-stack-2x"></i>
        <i class="fas fa-play fa-stack-1x fa-inverse"></i>
      </span>
      <h5 class="pb-2 font-weight-bold">{{'Optez pour un parcours d’apprentissage digitalisé avec le campus virtuel' | translate}}</h5>
      <p>{{ 'Un espace 100% virtuel, immersif et collaboratif pour stimuler vos formations. Clé en main, ludique et simple à déployer, le campus virtuel est un outil idéal pour organiser, quand vous le souhaitez, vos formations et vos évènements à distance. Personnalisez le campus à votre image, paramétrez votre avatar, échangez et explorez nos nombreux espaces : salles de réunion, de conférences, de formations, cinéma, ..' | translate}}.</p>
      <button class="btn green-button mt-1 btn-rounded" [routerLink]="language.navigateAccordingToLang(['/content/201'])" title="virtual campus"><i class="fas fa-info-circle mr-2"></i>{{'En savoir plus' | translate}}</button>
    </div>

</div>


<hr class="mt-5">
<div class="reassurance">
    <div class="container py-4 mb-4">
        <h3 class="my-4">{{ 'Ils nous font confiance' | translate}}</h3>
        <owl-carousel
            [options]="{
                items: 5,
                dots: false,
                nav: true,
                margin:0,
                loop:true,
                autoplay:true,
                autoplayTimeout:3000,
                autoplayHoverPause:true,
                responsive:{
                    '300':{
                        items:1,
                        nav:true
                    },
                    '768':{
                        items:3,
                        nav:true
                    },
                    '992':{
                        items:5,
                        nav:true,
                        loop:true
                    }
                }
            }"
            [carouselClasses]="['owl-carousel']">
            <div class="logos-theytrustus" *ngFor="let image of images;let i = index">
                <picture>
                    <source srcset="{{image.url}}.webp" type="image/webp">
                    <source srcset="{{image.url}}.png" type="image/png">
                    <img src="{{image.url}}.png" [attr.alt]="image.alt" [attr.title]="image.title" loading="lazy">
                </picture>
            </div>
        </owl-carousel>
    </div>
</div>
<hr *ngIf="blocnews" class="my-4">


<div *ngIf="blocnews" class="container">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'Envie d’en savoir plus sur les avantages qu’offre l’immersive learning pour le secteur universitaire ?' | translate}}</span>
    </div>
    <div class="container my-5">
      <p class="justif-center">{{ 'Découvrez le témoignage de l’association Mines Albi Alumni qui a organisé un évènement à succès sur notre campus virtuel :' | translate}}</p>
      <div *ngIf="blocnews" class="mt-4">
        <div class="post row pr-0">
            <div class="col-12 col-md-6 mb-md-0 px-0">
                <a *ngIf="blocnews['link']" [routerLink]="language.navigateAccordingToLang([blocnews['link']])" target="blank" rel="noopener nofollow" title="{{blocnews['title']}}"><img *ngIf="blocnews['imageHeader']" src='{{blocnews.imageHeader}}' class="news-image abstract-formation" alt='{{blocnews.title}}' title="Conference room" loading="lazy"></a>
            </div>
            <div class="col-12 col-md-6 px-4 pt-4 mb-4 d-flex justify-content-center align-items-center">
                <div>
                    <p *ngIf="blocnews['title']" class="font-weight-bold ifsolution">{{blocnews["title"]}}</p>
                    <div class="informations my-3">
                        <span *ngIf="blocnews['createdDate']" class="date">{{blocnews["createdDate"]}}</span>
                        <div *ngIf="blocnews.tag['title']" class="tag rounded px-2">{{blocnews.tag["title"]}}</div>
                    </div>
                    <div class="actu-body">
                      <p *ngIf="blocnews['shortDesc']" class="description" [innerHTML]="blocnews['shortDesc']"></p>
                      <a *ngIf="blocnews['link']" [routerLink]="language.navigateAccordingToLang([blocnews['link']])" class="viewmore mb-3" target="blank" rel="noopener nofollow" title="{{blocnews['title']}}">{{'Voir plus' | translate}}</a>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
</div>

<section class="blue py-5 mt-1">
<div class="container py-4">
    <!-- <div class="text-center mb-4">
        <span class="title sub-bar">{{'Les avis de nos clients sont unanimes' | translate}}</span>
    </div> -->
    <div class="row">
        <div class="col-12">
            <app-carousel-people [slides]="slides2"></app-carousel-people>
        </div>
    </div>
</div>
</section>

<hr class="mb-4 mt-0 pt-0">


<div class="container">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'Envie d’en savoir plus ? Découvrez notre livre blanc' | translate}}</span>
    </div>

    <div class="container-fluid mb-5">
        <div class="row">
            <div class="col-md-6 col-12 latest-pub">
                <h2 class="title-pub bold px-4 pt-2">{{'Téléchargez gratuitement notre livre blanc' | translate}}</h2>
                <h3 class="text-pub mt-2 px-4">{{'Analyse critique des modèles d’apprentissage' | translate}}</h3>
                <a href="https://communication.immersivefactory.com/{{'FR_Analyse_Critique_Modeles_Apprentissage.pdf' | translate}}" target="_blank" rel="noopener nofollow" title="Critical Analysis of Learning Models">
                <div class="download-btn mt-4">
                    <i class="fas fa-download"></i><span class="ml-2">{{'Télécharger' | translate}}</span>
                </div>
                </a>
            </div>
            <div class="col-md-6 col-12 book">
                <div class="magasine magasine-{{language.lang}}">
                </div>
            </div>
        </div>
    </div>
</div>

<hr class="mb-4 mt-0 pt-0">

<div class="container mb-5" *ngIf="workshops && workshops.length">
    <div class="text-center my-5 mb-5">
        <span class="title sub-bar">{{'exercices dédiés au secteur universitaire' | translate}}</span>
    </div>
    <div class="mt-4">
        <div class="row ml-0 mr-0 justify-content-center">
          <app-product-card class="col-md-4 mt-4"  *ngFor="let w of workshops" [product]="w"></app-product-card>
        </div>
    </div>
</div>
